import React from 'react';

interface WeeklyWorkingSchedule {
  dayFrom: string;
  dayTo?: string;
  from: string;
  to: string;
  intervals?: string[];
}

const DisplayDays = ({ dayFrom, dayTo }: Pick<WeeklyWorkingSchedule, 'dayFrom' | 'dayTo'>) => {
  return (
    <>
      {dayFrom}
      {dayTo ? <span> - {dayTo}</span> : ''}
    </>
  );
};

const DisplayHours = ({ from, to, intervals }: Omit<WeeklyWorkingSchedule, 'dayFrom' | 'dayTo'>) => {
  if (!to) {
    return <span>{from}</span>;
  }
  return intervals && intervals.length ? (
    <span>{intervals.join(', ')}</span>
  ) : (
    <span>
      {from} - {to}
    </span>
  );
};

const StoreWorkingHours = ({ from, to, dayFrom, dayTo, intervals }: WeeklyWorkingSchedule) => {
  return (
    <div>
      <DisplayDays dayFrom={dayFrom} dayTo={dayTo} />
      {': '}
      <DisplayHours from={from} to={to} intervals={intervals} />
    </div>
  );
};

export default StoreWorkingHours;
